import { render, staticRenderFns } from "./CustomerChatBtn.vue?vue&type=template&id=b3f2721e&"
import script from "./CustomerChatBtn.vue?vue&type=script&lang=js&"
export * from "./CustomerChatBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports